import { FC } from "react";
import { List } from "../List/List";
import { Pragraph } from "../Pragraph/Pragraph";

export const ThridSection: FC = () => {
  return (
    <li>
      <div>3. 第三者提供</div>
      <Pragraph>
        当社は、次に掲げる場合を除き、当社が取り扱う個⼈情報を、あらかじめお客様の同意を得ないで、第三者に提供いたしません。
      </Pragraph>
      <List
        items={[
          { index: "①", title: "法令に基づく場合。" },
          {
            index: "②",
            title:
              "⼈の⽣命、⾝体⼜は財産の保護のために必要がある場合であって、お客様の同意を得ることが困難であるとき。",
          },
          {
            index: "③",
            title:
              "公衆衛⽣の向上⼜は児童の健全な育成の推進のために特に必要がある場合であって、お客様の同意を得ることが困難であるとき。",
          },
          {
            index: "④",
            title:
              "国の機関若しくは地⽅公共団体⼜はその委託を受けた者が法令の定める事務を遂⾏することに対して協⼒する必要がある場合であって、お客様の同意を得ることにより当該事務の遂⾏に⽀障を及ぼすおそれがあるとき。",
          },
          { index: "⑤", title: "その他法令で認められる場合。" },
        ]}
      />
    </li>
  );
};
